module.exports = __webpack_public_path__ + "static/media/QuoteSentIllustration.774f3333.svg";